import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "../data/products";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0a0a0a]" data-testid="site-footer">
    <div className="max-w-[1600px] mx-auto px-6 sm:px-10 pt-24 pb-10">
      <Reveal>
        <Link to="/contact" data-testid="footer-cta" className="group block">
          <p className="overline-label mb-6">Ready to source?</p>
          <h2 className="font-display font-black tracking-tighter leading-[0.9] text-[clamp(3rem,10vw,8.5rem)] text-[#f5f5f5] transition-colors duration-500 group-hover:text-[#D97736]">
            LET'S TALK
            <ArrowUpRight
              className="inline-block ml-3 w-[0.55em] h-[0.55em] text-[#D97736] transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2"
              strokeWidth={2.5}
            />
          </h2>
        </Link>
      </Reveal>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-12 border-t border-white/10 pt-14">
        <div>
          <p className="font-mono-jb text-[10px] uppercase tracking-[0.3em] text-[#f5f5f5]/40 mb-5">
            Contact
          </p>
          <a
            href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}
            data-testid="footer-phone"
            className="flex items-center gap-3 text-[#f5f5f5]/85 hover:text-[#D97736] transition-colors duration-300 mb-3"
          >
            <Phone className="w-4 h-4 text-[#D97736]" /> {CONTACT.phone}
          </a>
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="footer-email"
            className="flex items-center gap-3 text-[#f5f5f5]/85 hover:text-[#D97736] transition-colors duration-300"
          >
            <Mail className="w-4 h-4 text-[#D97736]" /> {CONTACT.email}
          </a>
        </div>
        <div>
          <p className="font-mono-jb text-[10px] uppercase tracking-[0.3em] text-[#f5f5f5]/40 mb-5">
            Head Office
          </p>
          <p className="flex gap-3 text-sm text-[#f5f5f5]/60 leading-relaxed" data-testid="footer-address">
            <MapPin className="w-4 h-4 shrink-0 mt-0.5 text-[#D97736]" />
            {CONTACT.headOffice}
          </p>
        </div>
        <div className="md:text-right flex flex-col md:items-end justify-between gap-8">
          <div>
            <p className="font-display text-3xl font-black tracking-tighter">
              MSD<span className="text-[#D97736]">FOODS</span>
            </p>
            <p className="font-mono-jb text-[10px] uppercase tracking-[0.3em] text-[#f5f5f5]/40 mt-2">
              Manufacturers &amp; Exporters
            </p>
          </div>
          <nav className="flex md:justify-end gap-6 font-mono-jb text-xs uppercase tracking-[0.2em]">
            <Link to="/about" data-testid="footer-link-about" className="text-[#f5f5f5]/60 hover:text-[#D97736] transition-colors duration-300">About</Link>
            <Link to="/products" data-testid="footer-link-products" className="text-[#f5f5f5]/60 hover:text-[#D97736] transition-colors duration-300">Products</Link>
            <Link to="/quality" data-testid="footer-link-quality" className="text-[#f5f5f5]/60 hover:text-[#D97736] transition-colors duration-300">Quality</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="text-[#f5f5f5]/60 hover:text-[#D97736] transition-colors duration-300">Contact</Link>
          </nav>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono-jb text-[10px] uppercase tracking-[0.25em] text-[#f5f5f5]/35">
          © {new Date().getFullYear()} MSD Foods. All rights reserved.
        </p>
        <p className="font-mono-jb text-[10px] uppercase tracking-[0.25em] text-[#f5f5f5]/35">
          G.I.D.C. Vatva, Ahmedabad — India
        </p>
      </div>
    </div>
  </footer>
);
